<template>
    <organisation-index>
        <template v-slot:title>
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Suppliers</h1>
        </template>
        <template v-slot:searchfilter>
            <search-filter :show-filter="false" v-model:value="form.search" class="w-1/2 max-w-md mr-4" @reset="reset"></search-filter>
        </template>
        <template v-slot:filters>
            <v-select multiple class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm" style="width:150%!important;"
                :class="{'border-red-500': form.errors['filter.trading_details']}" :options="filters.trading_details" label="display_name" :reduce="trading_detail => trading_detail.id" v-model="form.filter.trading_details" placeholder="Trading Details" />
            <select id="project_status_country" v-model="form.filter.country"
                    class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value selected v-html="'Country'"></option>
                <option v-for="country in filters.countries" :value="country.id"
                        v-html="country.name"></option>
            </select>
            <select id="project_status_type" v-model="form.filter.type"
                    class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value selected v-html="'Type'"></option>
                <option v-for="(type, index) in filters.types" :key="index" :value="type.id" v-html="type.name"></option>
            </select>

            <v-select class="mt-1 block w-2/3 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
                :class="{'border-red-500': form.errors['filter.sort_by']}" :options="sort_by" label="label" :reduce="option => option.id" v-model="form.filter.sort_by" placeholder="Sort By" />

            <div class="flex gap-2 w-1/2">
                <button @click="toggleDirection" class="pt-1 pl-3">
                    <span v-if="form.filter.direction === 'asc'" class="flex">
                        <ArrowNarrowDownIcon class="w-5 h-5 text-light-pitch-purple"></ArrowNarrowDownIcon> <span class="text-sm text-gray-900 italic">ASC</span>
                    </span>
                    <span v-else-if="form.filter.direction === 'desc'" class="flex">
                        <ArrowNarrowUpIcon class="w-5 h-5 text-light-pitch-purple"></ArrowNarrowUpIcon> <span class="text-sm text-gray-900 italic">DESC</span>
                    </span>
                    <span v-else>
                        Direction
                    </span>
                </button>
            </div>
            <div>
                <a
                    :href="'/organisations/suppliers/export?filter[country]=' + this.form.filter.country +
                    '&filter[type]=' + this.form.filter.type +
                    '&filter[sort_by]=' + this.form.filter.sort_by +
                    '&filter[direction]=' + this.form.filter.direction"
                    @click="exportSupplier()"
                    class="
                    cursor-pointer inline-flex items-center px-6 py-2 bg-gray-500 border border-transparent
                    rounded-md font-semibold text-xs text-white uppercase
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    <DownloadIcon class="-ml-0.5 mr-2 h-4 w-4" />
                    Export
                </a>
            </div>
        </template>
        <Head title="Suppliers"/>
        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Type
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Location
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Phone
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">
                                        Contacts
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        CMID
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        SMID
                                    </th>

                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="organisations.data.length > 0"
                                    v-for="(organisation,index) in organisations.data" :key="index"
                                    :class="{'bg-gray-100': index % 2}" class="hover:bg-gray-50 cursor-pointer">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex">
                                        <img :src="'/images/' + organisation.flag + '.svg'" width="20" />
                                        <Link
                                            :href="route('frontend.organisations.suppliers.organisation.show' , organisation.id)" class="pl-3">
                                            <div class="text-sm text-gray-900">{{ organisation.name }}</div>
                                            <div class="text-sm text-gray-500">{{
                                                    organisation.registered_legal_name
                                                }}
                                            </div>
                                        </Link>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ organisation.type }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <div class="text-sm text-gray-900">{{ organisation.regions }}</div>
                                        <div class="text-sm text-gray-500">{{ organisation.country }}</div>
                                    </td>
                                    <td class="flex flex-col px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="organisation.telephone !== null">T: {{
                                                organisation.telephone
                                            }}</span>
                                        <span v-if="organisation.mobile !== null">M: {{ organisation.mobile }}</span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <div class="w-full flex justify-center items-center gap-3">
                                            <span class="underline text-pitch-purple text-gray-500 "
                                                  @click="editContacts(organisation)">{{
                                                    Object.keys(organisation.contacts).length
                                                }}</span>
                                            <button @click="editContacts(organisation)" type="button"
                                                    class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                <PlusSmIcon class="h-4 w-4 text-white" aria-hidden="true"/>
                                            </button>
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ organisation.cmid }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ organisation.smid }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <Link
                                            :href="route('frontend.organisations.suppliers.organisation.show' , organisation.id)">
                                            <PencilAltIcon class="w-5 h-5 text-light-pitch-purple"></PencilAltIcon>
                                        </Link>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td colspan="8" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        There are no suppliers available for your search criteria.
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Pagination :links="organisations.links"/>
            </div>
        </div>
        <CreateContacts ref="createContactsSlideOut"/>
    </organisation-index>
</template>

<script>

import {ref} from "vue";
import pickBy from "lodash/pickBy";
import debounce from "lodash/debounce";
import mapValues from "lodash/mapValues";
import {PlusSmIcon} from "@heroicons/vue/solid";
import Pagination from "@/Components/Pagination";
import Authenticated from "@/Layouts/Authenticated";
import SearchFilter from "@/Components/SearchFilter";
import {useForm, usePage, Link, Head} from "@inertiajs/vue3";
import CreateContacts from "@/Components/SlideOuts/CreateContacts";
import SlideoutFlashMessage from "@/Components/SlideoutFlashMessage";
import OrganisationIndex from "@/Pages/Frontend/Organisations/Index";
import {PencilAltIcon, DownloadIcon, ArrowNarrowDownIcon, ArrowNarrowUpIcon} from "@heroicons/vue/outline";

export default {
    layout: Authenticated,
    components: {
        Link,
        Head,
        PlusSmIcon,
        Pagination,
        SearchFilter,
        DownloadIcon,
        PencilAltIcon,
        Authenticated,
        CreateContacts,
        ArrowNarrowUpIcon,
        OrganisationIndex,
        ArrowNarrowDownIcon,
        SlideoutFlashMessage
    },
    props: ['organisations', 'filters', 'user_trading_details', 'open_contacts_slideout'],
    data() {
        return {
            form: useForm({
                search: null,
                filter: {
                    trading_details: "",
                    country: "",
                    type: "",
                    sort_by: "name",
                    direction: "asc"
                }
            })
        }
    },
    methods: {
        reset() {
            this.form.search = null;
        },
        editContacts(organisation) {
            this.$refs.createContactsSlideOut.organisation = organisation;
            this.$refs.createContactsSlideOut.contacts = organisation.contacts;
            this.$refs.createContactsSlideOut.open();
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('frontend.organisations.suppliers.index'), pickBy(this.form), {
                    preserveState: true
                });
            }, 500),
        },
    },
    mounted() {
        if (this.open_contacts_slideout) {
            this.editContacts(this.organisations.data[0]);
        }
    },
    computed: {
        sort_by() {
            return this.filters.sortby;
        }
    }
}
</script>
